export default "__VITE_ASSET__9719b39e__"